import CategoryQuiz from "@/components/CategoryQuiz";

const CategoryQuizPage = () => {
  return <CategoryQuiz />;
};

export default CategoryQuizPage;
